<template>
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-bind:key="item.text" v-for="item in imgs">
        <div class="swiper-zoom-container">
          <img :src="item.src" />
          <div class="item-foot-descripe">
            <div class="cnfont">{{ item.text }}</div>
            <div class="enfont">{{ item.textEn }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "./js/swiper-3.4.2.min.js";
export default {
  props: ["imgs"],
  name: "Swiper",
  data() {
    return {};
  },
  methods: {
    initSwiper() {
      const swip = new Swiper(".swiper-container", {
        loop: true
      });
    }
  },
  created() {},
  mounted() {
    this.initSwiper();
  }
};
</script>
<style scoped>
@import url("./css/swiper-3.4.2.min.css");
.swiper-container {
  position: relative;
  width: 100%;
}
.item-foot-descripe {
  width: 100%;
  background: rgba(242, 242, 242, 1);
}
.swiper-zoom-container {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.cnfont {
  text-align: left;
  margin-top: 17.5px;
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 9.5px;
  font-size: 10px;
  color: rgba(32, 32, 32, 1);
  line-height: 20px;
}
.enfont {
  text-align: left;
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 20px;
  font-size: 9px;
  color: rgba(32, 32, 32, 1);
  line-height: 16px;
}
</style>
